import axios from "axios";

const endpoint_url = "/campaignV2/customer/luckyDraw/unclaimList";

const getUnclaimList = ({
  luckyDrawUuid,
  limit = 50,
  skip = 0,
  searchText,
  searchType,
  wonDateStart,
  wonDateEnd,
  prizeType,
}) => {
  return new Promise((resolve, reject) => {
    const params = {
      luckyDrawUuid,
      limit,
      skip,
    };

    // Add optional parameters only if they have values
    if (searchText) params.searchText = searchText;
    if (searchType) params.searchType = searchType;
    if (wonDateStart) params.wonDateStart = wonDateStart;
    if (wonDateEnd) params.wonDateEnd = wonDateEnd;
    if (prizeType) params.prizeType = prizeType;

    axios
      .get(endpoint_url, { params })
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getUnclaimList;
